import {getTestProps} from '@benchling/js-test-utils';
import {ActionIcon, Tooltip} from '@mantine/core';
import React, {useCallback} from 'react';

import BenchlingIcon from 'ui-library/icons/BenchlingIcon';

import {setRightSidebarOpen, useAISidepanelGlobalClientState} from './AISidepanelV2GlobalClientState';

/**
 * Header control (LLM_ENABLE_RIGHT_SIDEBAR) that opens and closes the right sidebar. The
 * open state lives in the shared AI panel state (see AISidepanelV2GlobalClientState) so this button
 * and the sidebar's own close button stay in sync while sitting far apart in the tree.
 */
export default function RightSidebarToggle(): JSX.Element {
  const [panelState] = useAISidepanelGlobalClientState();
  const isOpen = panelState.showRightSidebar;

  const handleToggle = useCallback(() => {
    setRightSidebarOpen(!isOpen);
  }, [isOpen]);

  return (
    <Tooltip label={isOpen ? 'Hide sidebar' : 'Show sidebar'} withArrow={true}>
      <ActionIcon
        variant="subtle"
        size="md"
        aria-label={isOpen ? 'Hide sidebar' : 'Show sidebar'}
        aria-pressed={isOpen}
        onClick={handleToggle}
        {...getTestProps({component: 'RightSidebarToggle', element: 'root'})}
      >
        {/* TODO(alden): Replace with the new icon */}
        <BenchlingIcon icon="folder-tree" />
      </ActionIcon>
    </Tooltip>
  );
}
